<template>
  <section>
    <div v-if="!c">
      <p>Пропущен параметр "c"</p>
    </div>

    <div v-if="c==='offer-list'">
      <offer-list
        :offers="offersList.offers"
        :initial-cart="initialCart"
      />
    </div>

    <div v-if="c==='product-list'">
      <product-list
        :products="initialProducts"/>
    </div>

    <div v-if="c==='category-product-list'">
      <nav class="gl-breadcrumb breadcrumb">
        <ul>
          <li><a>Bulma</a></li>
          <li><a>Documentation</a></li>
          <li><a>Components</a></li>
          <li class="is-active"><a>Breadcrumb</a></li>
        </ul>
      </nav>

      <category-product-list
        :base-url="baseUrl"
        :initial-filter="initialFilter"
        :filter-values="filterValues"
        :initial-products="initialProducts"
        :initial-count="initialCount"
        :initial-child-categories="childCategories"
        :initial-available-child-category-ids="availableChildCategoryIds"
        :initial-available-model-ids="availableModelIds"
        :initial-available-tag-ids="availableTagIds"
        :initial-models="models"
        :initial-tags="tags"
        :page-size="6"
        :category="category"/>
    </div>

    <div v-if="c==='cart'">
      <cart/>
    </div>

    <div v-if="c==='order'">
      <p>Для формирования заказа надо заполнить корзину.</p>
      <order/>
    </div>

    <div v-if="c==='cart-info'">
      <cart-info
        :products="initialProducts"/>
    </div>
  </section>
</template>

<script>
  import CategoryProductList from 'glonass/shop/site/widgets/category-product-list/Widget.vue'
  import ProductList from 'glonass/shop/site/widgets/product-list/Widget.vue'
  import OfferList from 'glonass/shop/site/widgets/offer-list/Widget.vue'
  import Cart from 'glonass/shop/site/widgets/cart/Widget.vue'
  import Order from 'glonass/shop/site/widgets/order/Widget.vue'
  import CartInfo from 'glonass/shop/site/widgets/cart-info/Widget.vue'

  /**
   * Контейнер для отладки виджетов.
   */
  export default {
    mounted () {
      let url = new URL(window.location.href)
      this.c = url.searchParams.get('c')

      this.baseUrl = 'http://localhost:8080/site-hot.html?c=' + this.c

      global.siteStore.commit('shop/SET_INITIAL_STATE', {
        cart: this.initialCart
      })
    },

    data () {
      return {
        c: null,

        initialCart: [{
          'id': 47270,
          'rowId': 'c97d08be6c3a1cd85eab9e649096e265',
          'quantity': 2,
          'name': 'Размерный ряд',
          'price': 600,
          'total': 1200,
          'options': [],
          'product': {
            'data': {
              'id': 7664,
              'visible': true,
              'sorting': 84,
              'name': 'Футболка женская, однотонная, белая',
              'code': 'bog02',
              'slug': 'futbolka-zhenskaya-odnotonnaya-belaya',
              'url': '/shop/product/futbolka-zhenskaya-odnotonnaya-belaya',
              'rating': 0,
              'meta_tag': null,
              'short_description': 'Женская футболка из 100%-го хлопка. Плотность ткани - 140 гр./м.кв. Производитель - Узбекистан',
              'description': null,
              'kind_data': {
                't-shirt': {
                  'count': '1',
                  'designer': '',
                  'provider': 'Богатырь',
                  'sold_count': '6',
                  'created_date': '',
                  'sale_variant': '2',
                  'search_words': ['Женская белая футболка', 'Белая женская футболка'],
                  'stock_position': 'Б4',
                  'size_range_price': '120'
                }
              },
              'media': {
                'data': {
                  'images': [{
                    'id': 5341,
                    'type': 'images',
                    'small': 'http://restaurant.app/storage/media/5341/conversions/small.jpg',
                    'medium': 'http://restaurant.app/storage/media/5341/conversions/medium.jpg',
                    'big': 'http://restaurant.app/storage/media/5341/conversions/big.jpg',
                    'origin': 'http://restaurant.app/storage/media/5341/bog02.jpg'
                  }]
                }
              }
            }
          },
          'offer': {
            'data': {
              'id': 47270,
              'visible': true,
              'product_id': 7664,
              'name': 'Размерный ряд',
              'code': null,
              'price': 600,
              'quantity': 0
            }
          }
        }],

        offersList: {
          offers: [
            {id: 1, name: 'XXL', price: 800},
            {id: 3, name: 'XL', price: 210},
            {id: 2, name: 'L', price: 250},
            {id: 4, name: 'Размерный ряд', price: 2500}
          ]
        },

        baseUrl: '',
        initialFilter: {
          categories: [1, 3],
          models: [2, 3],
          tags: [4, 2]
        },
        initialCount: 30,
        filterValues: {
          categories: [
            {id: 1, name: 'тег 1', 'slug': 'slu1'},
            {id: 4, name: 'тег 4', 'slug': 'slu4'},
            {id: 2, name: 'тег 2', 'slug': 'slu2'},
            {id: 3, name: 'тег 3', 'slug': 'slu3'}
          ],
          models: [
            {id: 1, name: 'тег 1', 'slug': 'slu1'},
            {id: 4, name: 'тег 4', 'slug': 'slu4'},
            {id: 2, name: 'тег 2', 'slug': 'slu2'},
            {id: 3, name: 'тег 3', 'slug': 'slu3'}
          ],
          tags: [
            {id: 1, name: 'тег 1', 'slug': 'slu1'},
            {id: 4, name: 'тег 4', 'slug': 'slu4'},
            {id: 2, name: 'тег 2', 'slug': 'slu2'},
            {id: 3, name: 'тег 3', 'slug': 'slu3'}
          ]
        },
        // все
        childCategories: [
          {id: 1, name: 'тег 1', 'slug': 'slu1'},
          {id: 4, name: 'тег 4', 'slug': 'slu4'},
          {id: 2, name: 'тег 2', 'slug': 'slu2'},
          {id: 3, name: 'тег 3', 'slug': 'slu3'}
        ],
        models: [
          {id: 1, name: 'тег 1', 'slug': 'slu1'},
          {id: 4, name: 'тег 4', 'slug': 'slu4'},
          {id: 2, name: 'тег 2', 'slug': 'slu2'},
          {id: 3, name: 'тег 3', 'slug': 'slu3'}
        ],
        tags: [
          {id: 1, name: 'тег 1', 'slug': 'slu1'},
          {id: 4, name: 'тег 4', 'slug': 'slu4'},
          {id: 2, name: 'тег 2', 'slug': 'slu2'},
          {id: 3, name: 'тег 3', 'slug': 'slu3'}
        ],
        // доступные
        availableChildCategoryIds: [1, 2, 3],
        availableModelIds: [2, 4],
        availableTagIds: [1, 3],

        category: {
          id: 3,
          name: 'Раздел',
          slug: 's-risunkami',
          url: '/shop/s-risunkami'
        },
        initialProducts: [
          {
            name: 'товар 1',
            slug: 'slu1',
            url: '/shop/product/1',
            min_price: 300,
            code: 'cdff',
            offers: {
              data: [
                {id: 11223, price: 223}
              ]
            },
            images: {
              data: [{middle: 'http://via.placeholder.com/403x403'}]
            }
          },
          {
            name: 'товар 1',
            slug: 'slu1',
            url: '/shop/product/1',
            min_price: 300,
            code: 'cdff',
            images: {
              data: [{middle: 'http://via.placeholder.com/403x403'}]
            }
          },
          {
            name: 'товар 1',
            slug: 'slu1',
            url: '/shop/product/1',
            min_price: 300,
            code: 'cdff',
            images: {
              data: [{middle: 'http://via.placeholder.com/403x403'}]
            }
          },
          {
            name: 'товар 1',
            slug: 'slu1',
            url: '/shop/product/1',
            min_price: 300,
            code: 'cdff',
            images: {
              data: [{middle: 'http://via.placeholder.com/403x403'}]
            }
          }
        ]
      }
    },

    components: {
      CategoryProductList,
      ProductList,
      OfferList,
      Cart,
      CartInfo,
      Order
    }
  }
</script>



// WEBPACK FOOTER //
// Container.vue?4f6d9766